import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { ChevronRightIcon } from '../Icon/index';

const ExpandIcon = ({ isOpen, ...props }) => (
  <ChevronRightIcon
    aria-label={isOpen ? 'Collapse' : 'Expand'}
    {...props}
  />
);

ExpandIcon.propTypes = {
  isOpen: PropTypes.bool,
};

ExpandIcon.defaultProps = {
  isOpen: false,
};

const ExpandToggle = styled(ExpandIcon)`
  ${(props) => props.isOpen && css`transform: rotate(90deg);`}
`;

export default ExpandToggle;
